import { CenterPos, HeaderRow, ResultsColumnHeader, TitleText } from './DTRbiChallengeWidget.styles';
import React from 'react';
import { ChallengeItem } from './ChallengeItem';

export const COLUMN_WIDTH = {
  name: '20%',
  date: '20%',
  active: '10%',
  incentive: '15%',
  details: '15%',
};

export const ChallengeTable = ({ challenges, selectedChallengeId, handleChangeSelectedChallengeId }) => {
  return (
    <>
      <TitleText>Challenges</TitleText>
      <HeaderRow>
        <ResultsColumnHeader $width={COLUMN_WIDTH.name}>NAME</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.date}>START DATE</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.date}>END DATE</ResultsColumnHeader>
        <ResultsColumnHeader $justifyContent={'center'} $width={COLUMN_WIDTH.active}>
          ACTIVATION
        </ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.incentive}>INCENTIVE</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.details}>
          <CenterPos>STEPS</CenterPos>
        </ResultsColumnHeader>
      </HeaderRow>
      {challenges.map((challenge) => {
        return (
          <ChallengeItem
            key={challenge.id}
            challenge={challenge}
            selectedChallengeId={selectedChallengeId}
            handleChangeSelectedChallengeId={handleChangeSelectedChallengeId}
          />
        );
      })}
    </>
  );
};
